/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import AppContext from "../Utils/appContext";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import ProductCacheContext from "../Utils/productCacheContext";
import {
  checkIfSubCategoryHaveMoreChidCategory,
  extractIdFromGid,
} from "../Utils/categories-divide";
import useScrollRestoration from "../Hooks/useScrollRestoration";
import { saveScrollPosition } from "../Utils/scrollPositionManager";
import { getProductsByCategoryId } from "../Utils/api-service";
import ProductAutoScroll from "./ProductAutoScroll";
import { vibrate } from "../Utils/util-service";

let backUpCategory = [];
const SubCategoryGrid = React.memo(() => {
  useScrollRestoration();
  const navigate = useNavigate();
  const location = useLocation();
  const { clearProductCache } = React.useContext(ProductCacheContext);
  let [searchParams] = useSearchParams();
  const [subCats, setSubCats] = React.useState([]);
  const [filters, setFilters] = React.useState([]);
  const [mainCatgeory, setMainCategory] = React.useState("");
  const [featuredProducts, setFeaturedProducts] = React.useState([]);

  const { subCategories, level3Categories, showPrice } =
    React.useContext(AppContext);
  const categoryID = searchParams.get("categoryID");

  React.useEffect(() => {
    clearProductCache();
  }, []);

  React.useEffect(() => {
    const subCollections = [];
    const filterArr = [];
    subCategories.forEach((collection) => {
      if (collection.parentMainId === categoryID) {
        subCollections.push(collection);
        if (
          collection?.description &&
          !filterArr.includes(collection.description)
        ) {
          filterArr.push(collection.description);
        }
      }
    });
    setSubCats(subCollections);
    backUpCategory = subCollections;
    setMainCategory(subCollections[0]?.parentTitle);
    setFilters(filterArr);
  }, [subCategories, categoryID]);

  React.useEffect(() => {
    if (!categoryID) return;

    let cancelled = false;
    setFeaturedProducts([]);

    getProductsByCategoryId(categoryID)
      .then((data) => {
        if (cancelled) return;
        if (data?.status === 200) {
          setFeaturedProducts(data?.data?.collection?.products?.nodes || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching featured products:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [categoryID]);

  const filterCategory = (name) => {
    const subCollections = [];
    backUpCategory.forEach((collection) => {
      if (collection?.description && collection.description === name) {
        subCollections.push(collection);
      }
    });
    setSubCats(subCollections);
  };

  const allCategory = () => {
    setSubCats(backUpCategory);
  };

  const goTo = (val) => {
    saveScrollPosition(location.pathname);
    const level3rdCategory = checkIfSubCategoryHaveMoreChidCategory(
      val,
      level3Categories,
    );
    if (level3rdCategory) {
      return navigate(
        "/sub-category-3?categoryID=" +
          val.mainId +
          "&subCategoryID=" +
          val.parentMainId,
      );
    } else {
      navigate(
        "/product-list?categoryName=" +
          val?.subTitle +
          "&categoryId=" +
          val?.mainId,
      );
    }
  };

  const goToProduct = (id) => {
    const productId = extractIdFromGid(id);
    vibrate(20);
    navigate("/product?productId=" + productId);
  };

  return (
    <>
      <section className="pt-2 tab-section">
        <div id="estimate-header">
          <div className="back-links">
            <a onClick={() => navigate("/categories")}>
              <i className="iconly-Arrow-Left icli"></i>
            </a>
          </div>
          <div className="content">
            <h2>{mainCatgeory}</h2>
          </div>
        </div>
        {featuredProducts.length > 0 && (
          <section className="deals-section px-15 pt-0 pb-2 fade show active">
            <div className="title-part">
              <h2>Featured Products</h2>
            </div>
            <ProductAutoScroll
              products={featuredProducts}
              showPrice={showPrice}
              onProductClick={goToProduct}
              badgeFallback={<></>}
              showWishlist
              wishlistSource="RECOMMENDED"
            />
            <div className="divider"></div>
          </section>
        )}
        <div className="tab-section">
          <ul className="nav nav-tabs theme-tab pl-15">
            <li className="nav-item">
              <button
                className="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#trending"
                type="button"
                onClick={() => allCategory()}
              >
                All
              </button>
            </li>
            {filters.map((val, index) => {
              return (
                <li key={index} className="nav-item">
                  <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    data-bs-target="#top"
                    type="button"
                    onClick={() => filterCategory(val)}
                  >
                    {val}
                  </button>
                </li>
              );
            })}
          </ul>
          <div className="tab-content px-15">
            <div className="tab-pane fade show active">
              <div className="row gy-3 gx-3">
                {subCats.map((val, idx) => (
                  <div key={idx} className="col-md-4 col-6">
                    <div
                      onClick={() => goTo(val)}
                      className="product-box ratio_square"
                    >
                      <div className="img-part">
                        <a>
                          <img
                            src={
                              val?.image?.url || "assets/images/products/4.jpg"
                            }
                            alt=""
                            className="img-fluid bg-img"
                          />
                        </a>
                      </div>
                      <div className="product-content">
                        <a>
                          <h4>{val.subTitle}</h4>
                        </a>
                        {/* <div className="price">
                          <h4>subtitle</h4>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
});

export default SubCategoryGrid;
